import type { SharedTypes } from '@semios/app-platform-banyan-route-definitions'
import { ExternalVendorIcons } from 'components/ExternalVendorIcons/ExternalVendorIcons'
import { getExternalVendorIconItems } from 'utils/getExternalVendorIconItems'

export const LabelWithExternalVendorIcons = ({
  label,
  externalVendorNames = [],
  iconSize = 24,
}: {
  label: string
  externalVendorNames?: SharedTypes.IrrigationScheduler.EIrrigationVendorName[]
  iconSize?: number
}) => {
  if (getExternalVendorIconItems(externalVendorNames).length === 0) return label

  return (
    <span css={{ display: 'flex', flex: 1, alignItems: 'center', justifyContent: 'space-between', gap: 8 }}>
      <span>{label}</span>
      <ExternalVendorIcons externalVendorNames={externalVendorNames} size={iconSize} />
    </span>
  )
}
